const SAFE_DESTINATIONS = [
  "/dashboard",
  "/public/survey/",
  "/s/",
];

export const surveyTokenizeDestination = (value) => {
  if (typeof value !== "string") {
    return "/dashboard";
  }
  let destination = value;
  try {
    const parsed = new URL(value, window.location.origin);
    if (parsed.origin !== window.location.origin) return "/dashboard";
    destination = `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return "/dashboard";
  }
  if (!destination.startsWith("/") || destination.startsWith("//")) return "/dashboard";
  return SAFE_DESTINATIONS.some((path) => destination === path || destination.startsWith(path))
    ? destination
    : "/dashboard";
};
